"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatFunctions = {
    patterns: {
        DATE: /^(\d\d\d\d)-(\d\d)-(\d\d)$/,
        // DATET: /^(\d\d\d\d)-(\d\d)-(\d\d)((t|T|\s)(\d\d:\d\d:\d\d))?$/,
        DATE0: /^(\d\d\d\d)-(\d\d)-(\d\d)([t|T|\s](00:00:00))?$/,
        DAYS: [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        TIME: /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i,
        HOSTNAME: /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*$/i,
        // tslint:disable-next-line: max-line-length
        URI: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
        // tslint:disable-next-line: max-line-length
        URIREF: /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
        // uri-template: https://tools.ietf.org/html/rfc6570
        // tslint:disable-next-line: max-line-length
        URITEMPLATE: /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
        // For the source: https://gist.github.com/dperini/729294
        // For test cases: https://mathiasbynens.be/demo/url-regex
        // tslint:disable-next-line: max-line-length
        // @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
        // tslint:disable-next-line: max-line-length
        // var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
        // tslint:disable-next-line: max-line-length
        URL: /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i,
        UUID: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
        JSON_POINTER: /^(?:\/(?:[^~/]|~0|~1)*)*$/,
        JSON_POINTER_URI_FRAGMENT: /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
        RELATIVE_JSON_POINTER: /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
        // tslint:disable-next-line: max-line-length
        EMAIL_SIMPLE: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
        // tslint:disable-next-line: max-line-length
        EMAIL: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
        // tslint:disable-next-line: max-line-length
        // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
        // tslint:disable-next-line: max-line-length
        IPv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
        // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
        // tslint:disable-next-line: max-line-length
        IPv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
        KODPOCZTOWY: /^[0-9]{2}-[0-9]{3}$/,
        NUMERIC: /^\d+$/,
        NOT_URI_FRAGMENT: /\/|:/,
        DATE_TIME_SEPARATOR: /t|\s/i,
        Z_ANCHOR: /[^\\]\\Z/,
        GUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    },
    isLeapYear: function (year) { return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0); },
    date: function (str) {
        // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
        /*
        const matches = str
          .replace('T00:00:00', '')
          .replace(' 00:00:00', '')
          .match(formatFunctions.patterns.DATE);
        */
        // dopuszcony jest zerowy czas
        var matches = str.match(formatFunctions.patterns.DATE0);
        if (!matches) {
            return false;
        }
        var year = +matches[1];
        var month = +matches[2];
        var day = +matches[3];
        return month >= 1
            && month <= 12
            && day >= 1
            && day <= (month === 2 && formatFunctions.isLeapYear(year) ? 29 : formatFunctions.patterns.DAYS[month]);
    },
    time: function (str, full) {
        var matches = str.match(formatFunctions.patterns.TIME);
        if (!matches) {
            return false;
        }
        var hour = Number(matches[1]);
        var minute = Number(matches[2]);
        var second = Number(matches[3]);
        var timeZone = matches[5];
        return ((hour <= 23 && minute <= 59 && second <= 59)
            || (hour === 23 && minute === 59 && second === 60))
            && (!full || timeZone !== '');
    },
    kod: function (str) { return formatFunctions.patterns.KODPOCZTOWY.test(str); },
    date_time: function (str) {
        // http://tools.ietf.org/html/rfc3339#section-5.6
        var dateTime = str.split(formatFunctions.patterns.DATE_TIME_SEPARATOR);
        return dateTime.length === 2 && formatFunctions.date(dateTime[0]) && formatFunctions.time(dateTime[1], true);
    },
    hostname: function (str) { return str.length <= 255 && formatFunctions.patterns.HOSTNAME.test(str); },
    uri: function (str) { return formatFunctions.patterns.NOT_URI_FRAGMENT.test(str) && formatFunctions.patterns.URI.test(str); },
    url: function (str) { return formatFunctions.patterns.URL.test(str); },
    uuid: function (str) { return formatFunctions.patterns.UUID.test(str); },
    ipv4: function (str) { return formatFunctions.patterns.IPv4.test(str); },
    ipv6: function (str) { return formatFunctions.patterns.IPv6.test(str); },
    regex: function (str) {
        if (formatFunctions.patterns.Z_ANCHOR.test(str)) {
            return false;
        }
        try {
            // new RegExp(str);
            return new RegExp(str) !== null;
        }
        catch (e) {
            return false;
        }
    },
    // NIPWEIGHTS:  [6, 5, 7, 2, 3, 4, 5, 6, 7],
    nip: function (str) {
        var weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        str = str.replace(/[\s-]/g, '');
        if (str.length === 10) {
            var sum = 0;
            for (var i = 0; i < 9; i++) {
                var val = Number(str[i]);
                if (!isNaN(val)) {
                    sum += val * weights[i];
                }
            }
            return sum % 11 === Number(str[9]);
        }
        return false;
    },
    pesel: function (str) {
        var weights = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7];
        str = str.replace(/[\s-]/g, '');
        if (str.length === 11) {
            var sum = 0;
            for (var i = 0; i < 10; i++) {
                var val = Number(str[i]);
                if (!isNaN(val)) {
                    sum += val * weights[i];
                }
            }
            return sum % 10 === Number(str[10]);
        }
        return false;
    },
    regon: function (str) { return (str.length === 9 ? formatFunctions.regon9(str) : formatFunctions.regon14(str)); },
    regon9: function (str) {
        var weights = [8, 9, 2, 3, 4, 5, 6, 7];
        // if ((regon.length == 9) && (parseInt(regon, 9) > 0)) {
        if (str.length === 9) {
            var sum = 0;
            for (var i = 0; i < 8; i++) {
                var val = Number(str[i]);
                if (!isNaN(val)) {
                    sum += val * weights[i];
                }
            }
            var mod = sum % 11;
            if (mod === 10) {
                mod = 0;
            }
            return mod === Number(str[8]);
        }
        return false;
    },
    regon14: function (str) {
        var weights = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];
        // if ((regon.length == 14) && (parseInt(regon, 14) > 0)) {
        if (str.length === 14) {
            // czy regon konczy sie na 5 zer ? jesli tak to sprawdz go jako 9 elementowy
            if (str.endsWith('00000')) {
                return formatFunctions.regon9(str.substr(0, 9));
            }
            var sum = 0;
            for (var i = 0; i < 13; i++) {
                var val = Number(str[i]);
                if (!isNaN(val)) {
                    sum += val * weights[i];
                }
            }
            var mod = sum % 11;
            if (mod === 10) {
                mod = 0;
            }
            return mod === Number(str[13]);
        }
        return false;
    },
    iban: function (str) {
        if (str === '00000000000000000000000000') {
            return true;
        }
        str = str.replace(/[^0-9]+/g, '');
        var weights = new Array(1, 10, 3, 30, 9, 90, 27, 76, 81, 34, 49, 5, 50, 15, 53, 45, 62, 38, 89, 17, 73, 51, 25, 56, 75, 71, 31, 19, 93, 57);
        if (str.length === 26) {
            str = str + '2521';
            str = str.substr(2) + str.substr(0, 2);
            var Z = 0;
            for (var i = 0; i < 30; i++) {
                Z += Number(str[29 - i]) * weights[i];
            }
            if (Z % 97 === 1) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    },
    dowod: function (str) {
        str = str.replace(/[\s-]/g, '');
        // var numer = value.trim().replace(" ", "").replace("-", "");
        // Check length
        if (str == null || str.length !== 9) {
            return false;
        }
        str = str.toUpperCase();
        var letterValues = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
        function getLetterValue(letter) {
            return letterValues.indexOf(letter);
            // for (let j = 0; j < letterValues.length; j++)
            //    if (letter == letterValues[j])
            //        return j;
            // return -1;
        }
        // Check seria
        for (var i = 0; i < 3; i++) {
            if (getLetterValue(str[i]) < 10) {
                return false;
            }
        }
        // Check number
        for (var i = 3; i < 9; i++) {
            var glv = getLetterValue(str[i]);
            if (glv < 0 || glv > 9) {
                return false;
            }
        }
        // sprawdz cyfre controlna
        var sum = 7 * getLetterValue(str[0]) +
            3 * getLetterValue(str[1]) +
            1 * getLetterValue(str[2]) +
            7 * getLetterValue(str[4]) +
            3 * getLetterValue(str[5]) +
            1 * getLetterValue(str[6]) +
            7 * getLetterValue(str[7]) +
            3 * getLetterValue(str[8]);
        sum %= 10;
        if (sum !== getLetterValue(str[3])) {
            return false;
        }
        return true;
    },
    email: function (str) { return formatFunctions.patterns.EMAIL.test(str); },
    guid: function (str) { return formatFunctions.patterns.GUID.test(str); },
    numeric: function (str) { return formatFunctions.patterns.NUMERIC.test(str); }
};
function checkFormat(format, data) {
    return checkFormatFunction(format)(data);
}
exports.checkFormat = checkFormat;
function checkFormatFunction(format) {
    switch (format) {
        case 'date-time':
            return formatFunctions.date_time;
        case 'nrb':
            return formatFunctions.iban;
        case 'kodpocztowy':
            return formatFunctions.kod;
        case 'email':
        case 'date':
        case 'time':
        case 'uri':
        case 'url':
        case 'uuid':
        case 'hostname':
        case 'ipv4':
        case 'ipv6':
        case 'nip':
        case 'regon':
        case 'pesel':
        case 'iban':
        case 'regon9':
        case 'regon14':
        case 'dowod':
        case 'kod':
        case 'numeric':
            return formatFunctions[format];
        default:
            return function (str) { return true; };
    }
}
exports.checkFormatFunction = checkFormatFunction;
exports.default = formatFunctions;
//# sourceMappingURL=formatFunctions.js.map